/**
 * Canonical unit strings persisted in DB / templates map to budgetTemplate.unit_* i18n keys.
 */
export const BUDGET_UNIT_PART_I18N_KEYS: Record<string, string> = {
  天: 'budgetTemplate.unit_day',
  人: 'budgetTemplate.unit_person',
  月: 'budgetTemplate.unit_month',
  辆: 'budgetTemplate.unit_vehicle',
  间: 'budgetTemplate.unit_room',
  个: 'budgetTemplate.unit_piece',
  台: 'budgetTemplate.unit_set',
  米: 'budgetTemplate.unit_meter',
  千克: 'budgetTemplate.unit_kilogram',
  次: 'budgetTemplate.unit_occurrence',
  分: 'budgetTemplate.unit_minute',
  时: 'budgetTemplate.unit_hour',
  周: 'budgetTemplate.unit_week',
  年: 'budgetTemplate.unit_year',
};

export function translateBudgetUnitPart(
  u: string | null | undefined,
  t: (key: string) => string,
): string | undefined {
  if (u == null || u === '' || u === '--') return undefined;
  const path = BUDGET_UNIT_PART_I18N_KEYS[u];
  return path ? t(path) || u : u;
}
